/**
 * Lo que se ve dentro de la miniatura de un video: un cuadro del propio video,
 * con el botón de play encima para que se entienda que no es una foto.
 *
 * El cuadro lo pinta el navegador: `preload="metadata"` baja solo el comienzo
 * del archivo (los MP4 se suben con `+faststart`, así que ahí están el índice y
 * el primer cuadro), y `#t=0.1` le pide que muestre ese instante en vez de
 * quedar en negro. No hay póster aparte que subir ni que generar en el
 * servidor, que no tiene ffmpeg.
 *
 * Es decorativo: el nombre accesible lo pone el botón que lo envuelve.
 */
import type { VideoProducto } from '@bandu/compartido';

import { Icono } from '../comunes/Icono';

export function MiniaturaVideo({ video }: { video: VideoProducto }) {
  return (
    <>
      <video
        src={`${video.url}#t=0.1`}
        width={video.ancho}
        height={video.alto}
        muted
        playsInline
        preload="metadata"
        tabIndex={-1}
        aria-hidden="true"
      />
      <span className="miniatura-play" aria-hidden="true">
        <Icono nombre="reproducir" />
      </span>
    </>
  );
}
